<template>
    <div class="content-item" :class="{translucent: contentItem.translucent}" :id="contentItem.contentItemId">
        <span :style="defaultStyles" class="mi-folder-open top-0 mr-1"></span>
        <span class="ellipsis-nowrap">{{contentItem.title}}</span>
    </div>
</template>
<script>
import widgetContentItemRow from "@/mixins/general/widget-content-item-row";

export default {
    name: 'WidgetFolderRow',
    mixins: [widgetContentItemRow],
}
</script>
